
const actividadStyle = {
    backgroundColor: "#294235",
    padding: "40px",
    borderRadius: "20px",
    width: "420px",
    flexShrink: 0,
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
};

const tituloStyle = {
    fontWeight: "bold",
    letterSpacing: "1px",
};

export default function aventuraQueEducan() {
    return (
        <section className="my-12">
            <h2 className="text-center mb-9" style={{ fontSize: "2rem", fontWeight: "bold", letterSpacing: "2px",  color: "#005818",    background: "#ffffff"}}>
                AVENTURAS QUE EDUCAN
            </h2>
            <div  style={{display: "flex",  justifyContent: "center", gap: "30px",  overflowX: "auto",  padding: "20px",  }} >
                <div style={actividadStyle}>
                    <h2 className="text-white text-center mb-4  text bold " style={tituloStyle}>
                        Objetivo
                    </h2>
                    <p className="text-white" style={{ lineHeight: "1.8", alignContent: "center" }}>
                        Ofrecerle una valiosa oportunidad a los estudiantes para que vivencien experiencias significativas en contacto con la naturaleza.
                        En un entorno distinto al habitual, se promueve la convivencia, la autonomía y el trabajo en equipo.
                    </p>
                </div>
                <div style={actividadStyle}>
                    <h2 className="text-white text-center mb-4" style={tituloStyle}>
                        Destinos
                    </h2>
                    <p className="text-white" style={{ lineHeight: "1.8" }}> </p>
                </div>
            </div>
        </section>
    );
}
